module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("stworzył Jakub Bieńkowski © " + _vm._s(_vm.year))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h3', [_vm._v("Kontakt")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Katarzyna Bieńkowska")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:youngforever.biuro@gmail.com"
    }
  }, [_vm._v("youngforever.biuro@gmail.com")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+48691729207"
    }
  }, [_vm._v("+48 691 72 92 07")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae51c994"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MainFooter.vue
// module id = 49
// module chunks = 0